import React, { memo } from 'react';
import { useTranslation } from 'next-i18next';
import styles from '../styles/configuration.module.scss';
import { steps } from '../constants/configuration';
import { Dropdown } from 'react-dropdown-now';
import 'react-dropdown-now/style.css';

function ServiceWrapper({ service, changeActivity, value, disabled, children, preset, changePreset, presetOptions }) {
    const { t } = useTranslation('configuration');

    const stepNumbers = {
        'min': 0,
        'mid': 1,
        'max': 2,
        'custom': 3
    };

    return (
        <div className={styles.service}>
            <div className={'flex ' + styles['service-title']}>
                <div className={(disabled || service.isMain ? '' : 'pointer ') + 'flex'}
                    onClick={() => !disabled && changeActivity && changeActivity(!value)}
                    style={{ alignItems: 'center' }}>
                    {!service.isMain && <input checked={value} className={(disabled ? '' : 'pointer ') + 'flex'} readOnly disabled={disabled} type="checkbox" id={service.title.toLocaleLowerCase()} />}
                    {!service.isMain && <label htmlFor={service.title.toLocaleLowerCase()} className={styles["sr-only"]}>{t(`${service.title}.title`)}</label>}
                    {service.img && <img src={service.img} alt={t("serviceImageAlt")} />}
                    <h5>{t(`${service.title}.title`)}</h5>
                </div>
                { changePreset && <label style={{ marginLeft: 'auto' }}>
                    <p style={{ fontSize: '14px' }}>{t('infrastructure.preset')}</p>&ensp;
                    <Dropdown
                        disabled={disabled || value === false}
                        options={(presetOptions || steps).map((step, index) => ({ value: step, label: t(step) }))}
                        onChange={(e) => changePreset(stepNumbers[e.value])}
                        value={steps[preset] || steps[0]}
                        className={styles['dropdown-size']}
                    />
                </label>}
            </div>
            { !service.noDescription && <p className={styles.description}>{t(`${service.title}.description`)}</p> }
            { children }
        </div>
    )
};

export default memo(ServiceWrapper);
